import {
  URLMFXDataProvisionPolicy,
  URLMFXExternalToolsPrivacyPolicy,
  URLMFXIDTerms,
  URLMFXPrivacyPolicy,
  URLMFXPrivacyPolicyTreatment,
} from "@/libs/constants";
import {
  color,
  Footer,
  FooterItem,
} from "@moneyforward/mfx_biz_react_components";

export const ContentFooter = () => {
  const fi: FooterItem[] = [
    {
      text: "マネーフォワードエックス株式会社",
      links: [
        {
          text: "Mikatano ID 利用規約", //
          href: URLMFXIDTerms,
        },
        {
          text: "個人情報の取扱について", //
          href: URLMFXPrivacyPolicyTreatment,
        },
        {
          text: "利用者情報の第三者提供に関する特約",
          href: URLMFXDataProvisionPolicy,
        },
        {
          text: "外部送信ツールに関する公表事項",
          href: URLMFXExternalToolsPrivacyPolicy,
        },
      ],
    },
  ];

  return (
    <div
      css={{
        borderTop: `1px solid ${color.gray300}`,
        width: "100%",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <div
        css={{
          width: "100%",
          maxWidth: "1080px",
        }}
      >
        <Footer footerItems={fi} />
      </div>
    </div>
  );
};
